import React, { useEffect, useState } from "react";

import { getProductList } from "services/ProductsServices";

import Loader from "components/common/loader/Loader";
import Product from "components/ownProduct/Products";
import OwnProductsActionBar from "components/ownProduct/ownProductsActionBar";

import "./ownProducts.scss";
import { useTranslation } from "react-i18next";
const OwnProducts = () => {
  const { t } = useTranslation();
  const [productList, setProductList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    orderType: "DESC",
    searchString: "",
    orderBy: "",
  });
  const [resfresh, setRefresh] = useState(false);

  const orderByList = [{ value: "Type", name: t("type") }];
  const handleResetFilters = () => {
    setFilters({
      orderType: "DESC",
      searchString: "",
      orderBy: "",
    });
  };
  const handleChangeFilters = (key, value) => {
    setFilters((pre) => {
      let obj = { ...pre };
      obj[key] = value;
      return obj;
    });
  };

  const handleRefresh = () => {
    setRefresh((pre) => !pre);
  };

  useEffect(() => {
    const getProducts = async () => {
      setIsLoading(true);

      let params = {
        ...filters,
      };
      let result = await getProductList(params);
      if (result?.success) {
        setProductList(result?.payLoad?.items);
      }
      setIsLoading(false);
    };
    getProducts();
  }, [filters.orderType, filters.orderBy, filters.searchString, resfresh]);

  return (
    <div className="products w-100">
      <div className="custom-breadcrumbs ms-5 ps-5">
        <span className="breadcrumbs-item ">{t("products")}</span>
      </div>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <OwnProductsActionBar
            handleChange={handleChangeFilters}
            // handleSubmit={handleRefresh}
            orderByList={orderByList}
            filters={filters}
            resetFilters={handleResetFilters}
            searchPlaceholder={t("product-name")}
          />
          <Product productList={productList} handleRefresh={handleRefresh} />
        </>
      )}
    </div>
  );
};

export default OwnProducts;
